import { createReducer } from 'redux-create-reducer';

import { GET_NATIONALITIES } from '../types';

const initialState = [];

const nationalitiesReducer = createReducer(initialState, {
  [GET_NATIONALITIES.FULFILLED]: (state, { payload }) => payload.data,
});

export default nationalitiesReducer;


// WEBPACK FOOTER //
// ./src/reducers/nationalitiesReducer.js